import React, { useContext } from 'react'
import { InformationalDialog } from '@jarvis.oddle/core/components/Dialog'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { fetchMenu } from 'src/redux/menu'
import useAppDispatch from 'src/hooks/useAppDispatcher'
import modalController, { makeControlledModal } from 'src/decorators/ModalController'

// OMS appends prevCheck_ to error message set by the merchant
const getErrorMessage = (message = '') => message.split('prevCheck_')[1] || message

const CartErrorModal = ({
  modal,
  errors,
  errorCodes
}: {
  modal: {
    show: boolean
    onClose: () => void
    onClosed: () => void
  }
  errors: string[] | string
  errorCodes: string[] | string
}) => {
  const dispatch = useAppDispatch()
  const { t } = useContext(TranslationContext)

  const onConfirm = async () => {
    const shouldRefreshMenu = (errorCodes || []).includes('orderItemsNotAvailable')

    // if OMS throws orderItemsNotAvailable error. When user clicks the confirm button,
    // refetch the menu to ensure the product list section is updated with the latest
    // item availability status
    if (shouldRefreshMenu) {
      await dispatch(fetchMenu({}))
    }

    modalController.showModal('CartDrawer')
  }

  return (
    <InformationalDialog
      {...modal}
      closeOnBackdropClick={false}
      closeOnEscapeKeyPress={false}
      onConfirm={onConfirm}
      header={t('Unable to checkout')}
      body={t('Please fix the following errors before checkout:')}
      subText={(
        <ul>
          {Array.isArray(errors)
            ? errors.map((e, i) => (<li key={i}>{t(getErrorMessage(e))}</li>))
            : t(errors)}
        </ul>
      )}
      confirmText={t('Okay')}
    />
  )
}

export default makeControlledModal(CartErrorModal, 'CartErrorModal')
